/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Light_Frog_SingInputs */

const en_shy_light_frog_sing = /** @type {(inputs: Shy_Light_Frog_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add group`)
};

const de_shy_light_frog_sing = /** @type {(inputs: Shy_Light_Frog_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add group" |
*
* @param {Shy_Light_Frog_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_light_frog_sing = /** @type {((inputs?: Shy_Light_Frog_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Light_Frog_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_light_frog_sing(inputs)
	return de_shy_light_frog_sing(inputs)
});